import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AUTHORIZATIONS_QS } from '../../../../common/consts/systemQuerystring';
import { omitFromQs } from '../../../../common/utils/queryString';
import LoginFooter from '../LoginFooter';
import LoginUnsuccessful from '../LoginUnsuccessful';
import SelectProviders from '../SelectProviders';
import TermsAndPolicy from '../TermsAndPolicy/TermsAndPolicy';
import WelcomeHeader from '../WelcomeHeader';
import { LoginLoader } from './LoginLoader';
import Cookies from 'js-cookie';
import StyledLoginModal, { StyledLoginModalContent } from './LoginModal.style';
import { LoginContext } from '../../../root/views/dashboard/context/LoginContext';
import { useComponentDidMount } from '../../../../hooks/useComponentDidMount';
import { COOKIES_KEYS } from '../../../../common/consts';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '../../../../common/consts/featureFlags';

const LoginModal = () => {
  const enableGdprConsent = useFeatureFlag(FEATURE_FLAGS.GDPR_CONSENT);
  const [gdprConsentGiven, setGdprConsentGiven] = useState(false);
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();
  const parsedSearch = new URLSearchParams(search);
  omitFromQs(AUTHORIZATIONS_QS.ERROR);
  const autherr = parsedSearch.get(AUTHORIZATIONS_QS.ERROR);

  function onLoginStart() {
    setLoading(true);
  }

  useComponentDidMount(() => {
    if (enableGdprConsent) {
      const gdprConsentCookie = Cookies.get(COOKIES_KEYS.GDPR_CONSENT);
      setGdprConsentGiven(Boolean(gdprConsentCookie));
    } else {
      setGdprConsentGiven(true);
    }
  });

  const contextValue = useMemo(
    () => ({
      gdprConsentGiven,
      setGdprConsentGiven
    }),
    [gdprConsentGiven, setGdprConsentGiven]
  );

  return (
    <LoginContext.Provider value={contextValue}>
      <StyledLoginModal>
        {loading && <LoginLoader />}
        <StyledLoginModalContent>
          <WelcomeHeader />
          <SelectProviders onLoginStart={onLoginStart} />
          {autherr && <LoginUnsuccessful />}
          <TermsAndPolicy />
        </StyledLoginModalContent>
        <LoginFooter />
      </StyledLoginModal>
    </LoginContext.Provider>
  );
};

export default LoginModal;
